
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_41252_228747)"}},[_c('path',{attrs:{"d":"M16.12 16.75v.737h.737c.236 0 .406.184.406.388 0 .204-.17.388-.406.388H5.43c-1.497 0-2.692-1.193-2.692-2.638V4.375c0-1.445 1.195-2.638 2.692-2.638h11.428c.236 0 .406.184.406.388v11.25c0 .204-.17.388-.406.388h-.737v2.987zm-.811-2.25v-.737H5.429a1.87 1.87 0 00-1.88 1.862 1.87 1.87 0 001.88 1.862H15.309V14.5zM7.143 4.763c-.71 0-1.309.572-1.309 1.3 0 .485.266.901.655 1.125-.389.223-.655.64-.655 1.125 0 .727.598 1.3 1.309 1.3H14c.71 0 1.309-.573 1.309-1.3 0-.486-.266-.902-.655-1.126.389-.223.655-.64.655-1.125 0-.727-.598-1.3-1.309-1.3H7.143z","fill":"#999","stroke":"#999","stroke-width":"1.475"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_41252_228747"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 1)","d":"M0 0h16v18H0z"}})])])])
          )
        }
      }
    